var _line, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleuDePresiunePresostatContactNormalInchis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 41,
    x2: 22,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 41H28",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 41H34",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 31.5,
    width: 17,
    height: 17,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05682 45V36.2727H5.00568C5.69034 36.2727 6.25 36.3963 6.68466 36.6435C7.12216 36.8878 7.44602 37.2188 7.65625 37.6364C7.86648 38.054 7.97159 38.5199 7.97159 39.0341C7.97159 39.5483 7.86648 40.0156 7.65625 40.4361C7.44886 40.8565 7.12784 41.1918 6.69318 41.4418C6.25852 41.6889 5.7017 41.8125 5.02273 41.8125H2.90909V40.875H4.98864C5.45739 40.875 5.83381 40.794 6.1179 40.6321C6.40199 40.4702 6.60795 40.2514 6.7358 39.9759C6.86648 39.6974 6.93182 39.3835 6.93182 39.0341C6.93182 38.6847 6.86648 38.3722 6.7358 38.0966C6.60795 37.821 6.40057 37.6051 6.11364 37.4489C5.8267 37.2898 5.44602 37.2102 4.97159 37.2102H3.11364V45H2.05682ZM15.3161 41.1136L9.82741 43.9091V42.8182L14.0376 40.7898L14.0036 40.858V40.6875L14.0376 40.7557L9.82741 38.7273V37.6364L15.3161 40.4318V41.1136Z",
    fill: "#7C7C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31L30 14.8024L30 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30H45.9511H62.9022",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 82.6016L30 48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43 24.9023L30 49",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleuDePresiunePresostatContactNormalInchis);
export default __webpack_public_path__ + "static/media/releu_de_presiune_presostat_contact_normal_inchis.88d32d436da824e7395bc0dc91f62963.svg";
export { ForwardRef as ReactComponent };